// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyA3-TXPbrEWqLy94EPzh2LSX1kuryldSeY',
    authDomain: 'trainer-app-services.firebaseapp.com',
    projectId: 'trainer-app-services',
    storageBucket: 'trainer-app-services.appspot.com',
    messagingSenderId: '869346522288',
    appId: '1:869346522288:web:2c3bb600b06dbac4b4b775',
    measurementId: 'G-ZJZSLDR1HG',
  },
  backendUrl: 'http://localhost:3000',
  notificationApi: {
    production: false,
    url: 'http://localhost:5001/trainer-app-services/us-central1/sendNotification',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
